module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("THE THIRTEENTH")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe-page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("ALSO BY L. A. BANKS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("VAMPIRE HUNTRESS LEGENDS")])]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("Minion"), _c('br'), _vm._v("The Awakening"), _c('br'), _vm._v("The Hunted"), _c('br'), _vm._v("The Bitten"), _c('br'), _vm._v("The Forbidden"), _c('br'), _vm._v("The Damned"), _c('br'), _vm._v("The Forsaken"), _c('br'), _vm._v("The Wicked"), _c('br'), _vm._v("The Cursed"), _c('br'), _vm._v("The Darkness"), _c('br'), _vm._v("The Shadows")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CRIMSON MOON NOVELS")]), _c('br'), _c('em', [_vm._v("Bad Blood"), _c('br'), _vm._v("Bite the Bullet")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ANTHOLOGIES")]), _c('br'), _c('em', [_vm._v("Love at First Bite"), _c('br'), _vm._v("Stroke of Midnight")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dfe612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0